import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-5 py-3 flex flex-col items-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl leading-7 font-semibold tracking-wider text-blue-900 mb-2" }, " Konfirmasi ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm leading-6 text-center" }, " Password akan digenerate ulang dan dikirimkan kepada peserta ", -1)
const _hoisted_4 = { class: "w-full flex flex-col mt-3 gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    modelValue: $setup.isShown,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.isShown) = $event)),
    "hide-footer": "",
    "hide-header": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.resendEmailParticipant && $setup.resendEmailParticipant(...args))),
            class: "w-full px-4 py-2 bg-yellow-400 border-1 border-yellow-400 rounded text-white leading-6 text-sm font-semibold"
          }, " Kirim Ulang Email "),
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.close && $setup.close(...args))),
            class: "w-full px-4 py-2 bg-transparent border-1 border-yellow-400 rounded text-yellow-400 text-sm leading-6 font-semibold"
          }, " Batalkan ")
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}